import { gql } from '@apollo/client'

const upsertDfmAttachmentAnnotationsMutation = gql`
    mutation upsertDfmAttachmentAnnotationsImDfmModal(
        $attachmentId: UUID!
        $qmrAttachmentAnnotationsInput: DfmAttachmentAnnotationsInput!
        $newAnnotationsAdded: Boolean
    ) {
        upsertDfmAttachmentAnnotations(
            attachmentId: $attachmentId
            qmrAttachmentAnnotationsInput: $qmrAttachmentAnnotationsInput
            newAnnotationsAdded: $newAnnotationsAdded
        ) {
            id
            annotationsDataDownloadUrl
            attachmentId
            createdAt
            createdBy {
                id
                displayName
            }
            updatedAt
            updatedBy {
                id
                displayName
            }
        }
    }
`

export default upsertDfmAttachmentAnnotationsMutation
